import type { ButtonVariant } from '@/components/ui/Button';
import type { OrderAction } from '@/gql/graphql';

/** POS settlement flips — never shown or invoked from admin. */
const ADMIN_HIDDEN_ORDER_ACTIONS = new Set<OrderAction>([
  'PLACE',
  'PARTIAL_PAID',
  'PAY',
  'MARK_PAID',
]);

const ORDER_ACTION_ORDER: OrderAction[] = [
  'CANCEL',
  'FAIL',
  'PARTIAL_REFUND',
  'REFUND',
  'DOWNLOAD_RECEIPT',
];

export const ORDER_ACTION_LABELS: Record<OrderAction, string> = {
  CANCEL: 'Cancel',
  MARK_PAID: 'Mark paid',
  DOWNLOAD_RECEIPT: 'Download receipt',
  PLACE: 'Place',
  FAIL: 'Fail',
  PARTIAL_PAID: 'Partial paid',
  PAY: 'Pay',
  PARTIAL_REFUND: 'Partial refund',
  REFUND: 'Refund',
};

/** Actions available for bulk toolbar (no print). */
export const ORDER_BULK_ACTIONS: OrderAction[] = ORDER_ACTION_ORDER.filter(
  (action) => action !== 'DOWNLOAD_RECEIPT' && !ADMIN_HIDDEN_ORDER_ACTIONS.has(action),
);

/** Actions shown on the order detail page (includes DOWNLOAD_RECEIPT). */
export const ORDER_DETAIL_ACTIONS: OrderAction[] = ORDER_ACTION_ORDER.filter(
  (action) => !ADMIN_HIDDEN_ORDER_ACTIONS.has(action),
);

export function sortOrderDetailActions(actions: OrderAction[]): OrderAction[] {
  return [...actions]
    .filter((action) => !ADMIN_HIDDEN_ORDER_ACTIONS.has(action))
    .sort((a, b) => {
      const ai = ORDER_ACTION_ORDER.indexOf(a);
      const bi = ORDER_ACTION_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
}

export function orderActionLabel(action: OrderAction): string {
  return ORDER_ACTION_LABELS[action] ?? action;
}

export function orderActionVariant(action: OrderAction): ButtonVariant {
  if (
    action === 'CANCEL' ||
    action === 'FAIL' ||
    action === 'REFUND' ||
    action === 'PARTIAL_REFUND'
  ) {
    return 'danger';
  }
  return 'outline';
}
